import ToolTip from "components/General/ToolTip"

interface Props {
  grade: number | null
  comment: string | null
  show: boolean
}

const TeacherFeedback = ({ grade, comment, show } : Props) => {

  if (!show) return null

  return (
    <ToolTip title="Teacher feedback">
      <div className="my-3 p-3 border rounded bg-light">
        <p className="m-0">
          <i className="fa-solid fa-book" /> Grade - <span className="text-primary">{grade != null ? `${grade}/10` : "N/A"}</span>
        </p>
        {comment && 
          <p className="m-0">
            <i className="fa-solid fa-comments" /> Comment - <span className="text-primary">{comment}</span>
          </p>}
      </div>
    </ToolTip>
  )
}

export default TeacherFeedback
